import React from 'react';
import { TrendingUp, TrendingDown, Building2, Users, UserX } from 'lucide-react';

function AnalyticsCardSection({ analyticsData, loading, onCardClick, activeFilter }) {
  const defaultAnalyticsData = [
    {
      name: 'totalOrganizations',
      title: 'Total Organizations',
      value: analyticsData?.totalOrganizations?.count ?? 'N/A',
      icon: Building2,
      iconBgColor: '#3b82f628',
      iconColor: '#3b82f6',
      changeDifferenceCount: analyticsData?.totalOrganizations?.changeNum,
      filterType: 'all',
    },
    {
      name: 'activeOrganizations',
      title: 'Active Organizations',
      value: analyticsData?.activeOrganizations?.count ?? 'N/A',
      icon: Users,
      iconBgColor: '#10b98128',
      iconColor: '#10b981',
      changeDifferenceCount: analyticsData?.activeOrganizations?.changeNum,
      filterType: 'active',
    },
    {
      name: 'inactiveOrganizations',
      title: 'Inactive Organizations',
      value: analyticsData?.inactiveOrganizations?.count ?? 'N/A',
      icon: UserX,
      iconBgColor: '#ef444428',
      iconColor: '#ef4444',
      changeDifferenceCount: analyticsData?.inactiveOrganizations?.changeNum,
      filterType: 'inactive',
    }
  ];

  return (

    <div className="row" style={{ marginBottom: '-16px' }}>
      {defaultAnalyticsData.map((item, index) => {
        const Icon = item.icon;
        const isActive = activeFilter === item.filterType;
        return (
          <div key={index} className="col-lg-4 col-md-6 mb-3 ">
            <div
              className="card shadow-sm  hover:shadow-md p-3 hover-shadow cursor-pointer"
              style={{ border: isActive ? '2px solid #237fff' : '1px solid #e5e7ea', transition: 'all 0.2s ease' }}
              onClick={() => onCardClick(item.filterType)}
            >
              <div className="d-flex align-items-center justify-content-between">

                <div >
                  <div className="text-muted smallFont">
                    {item.title}
                  </div>
                  {loading ?
                    <div className="shimmer mt-2" style={{ width: '120px', height: '10px', borderRadius: '8px' }} />
                    :
                    <div className="d-flex align-items-end font-weight-bold xxxlargeFont ">
                      {item.value}
                      {item.changeDifferenceCount !== undefined && (
                        <div
                          className={` gap-1 tinyFont mx-2 mb-1 ${item.changeDifferenceCount === 0 ? 'text-muted' : item.changeDifferenceCount > 0 ? 'text-success' : 'text-danger'
                            }`}
                        >
                          {item.changeDifferenceCount > 0 ? (
                            <TrendingUp className='mr-1' style={{ width: '11px', height: '11px' }} />
                          ) : item.changeDifferenceCount < 0 ? (
                            <TrendingDown className='mr-1' style={{ width: '11px', height: '11px' }} />
                          ) : null}
                          <span>
                            {item.changeDifferenceCount > 0 ? '+' : ''}
                            {item.changeDifferenceCount || ''}
                          </span>
                        </div>
                      )}
                    </div>
                  }

                </div>

                <div className="d-flex align-items-center justify-content-center rounded-circle p-3" style={{ backgroundColor: item.iconBgColor }}>
                  <Icon style={{ color: item.iconColor }} />
                </div>
              </div>

            </div>
          </div>
        );
      })}
    </div>
  );
}

export default AnalyticsCardSection;
